import io from 'socket.io-client';

const socket = io(`${process.env.REACT_APP_NODE_END_POINT}`);  


export default socket;
